import React from 'react'
import heroimg from '../../assets/img/Hero.jpg'
import { motion } from "framer-motion";
import './Animation.css';

const Animation = () => {
    return (
        <div style={{backgroundColor:' #0c2340',overflow:"hidden",borderBottom: "1px solid #47c4ff", borderTop: "1px solid #47c4ff"}}>
            <div className="moving-text">
                “Without data, you’re just another person with an opinion.” W. Edwards Deming
            </div>
        </div>
    );
}
export default Animation;
